import qs from 'qs';

import ComponentModule from 'lib/component-module';
import fetcher from 'lib/fetcher';

import store from '../store';
import { infoModal as modal } from '../modals';

// Meter selector components
import 'lib/meter-selector/step-bar';
import 'lib/meter-selector/input-box';
import 'lib/meter-selector/button-set';
import 'lib/meter-selector/frame';

// Meter selector templates
import meterSelectorContentTemplate from 'shared/meter-selector-content.hbs';
import meterSelectorPaginatorTemplate from 'shared/meter-selector-paginator.hbs';
import productItemVTemplate from 'shared/meter-selector-product-item-v.hbs';
import productItemHTemplate from 'shared/meter-selector-product-item-h.hbs';

ComponentModule.AddModule('.meter-selector', {
    prefix: 'meter-selector-',
    components: [
        fetcher({
            props: {
                defaultCount: { type: Number, default: 0 },
                pageSize: { type: Number, default: 12 },
                requestQuoteButton: { type: String, default: '[href="#meterselector"]' },
            },
            data: function(){
                return {
                    // global
                    data: {},
                    
                    // results
                    count: this.defaultCount,

                    // questions
                    steps: [], 
                    stepNumber: 0,
                    answerMemo: [],
                    
                    questions: [],
                    answerModel: [],
                    disabledContinue: true,
                    notice: '',
                    debounce: null,
                    stepValues: [],
                    isResultsPage: false,
                    tagStepFlag: false,
                };
            },
            computed: {
                selectedUnit() {
                    return store.state.units;
                },
                filters(){
                    const filters = this.answerMemo.filter((_, i) => i < this.stepNumber ).reduce((a, aw) => {
                        if (!aw) {
                            return a;
                        }

                        const query = aw.reduce((ae, e) => ({...ae, ...e.query }), {});

                        return {...a, ...query };
                    } ,{});

                    return filters;
                },
                hasButtons(){
                    if (this.isResultsPage) {
                        return false;
                    }

                    const questions = this.getQuestions(this.stepNumber);
                    return Boolean(questions.find(q => q.button ));
                },
                isTransparent(){
                    return this.isResultsPage || this.questions.length === 0 || this.hasButtons;
                },
                title(){
                    if (this.isResultsPage) {
                        const { title } = (this.data) || {};
                        return title;
                    }

                    const tab = this.getTab(this.stepNumber);
                    return (tab && tab.tabTitle) || null;
                },
                message(){
                    if (!this.isResultsPage) {
                        return null;
                    }

                    const { content } = (this.data) || {};
                    return content;
                },
                closeLabel(){
                    const results = this.data.searchResults || {};
                    return results.CloseLabel;
                },
                nextLabel(){
                    const results = this.data.searchResults || {};
                    if (this.isResultsPage) {
                        return results.AdjustParamsLabel;
                    }

                    return results.NextLabel;
                },
                skipLabel(){
                    if (this.isResultsPage) {
                        return null;
                    }

                    return this.data.searchResults && this.data.searchResults.SkipForNowLabel;
                },
                loadingMessage(){
                    const results = this.data.searchResults || {};
                    return results.LoadingLabel;
                },
                contactButton(){
                    if (!this.isResultsPage) {
                        return null;
                    }

                    return this.data.searchResults && { label: this.data.searchResults.ContactProductExpertLabel };
                }
            },
            watch: {
                isResultsPage(){
                    if (!this.isResultsPage) {
                        return;
                    }

                    const { tabs = [] } = this.data;
                    const answerMemo = this.answerMemo;

                    const questions = tabs.reduce((a, t, it) => {
                        if (!t.questions){
                            return a;
                        }

                        const questions = t.questions.map((q,i) => {
                            return {...q, questionIndex: i, tabIndex: it };
                        }).filter(q => !q.button);

                        return [...a, ...questions];
                    }, []); 

                    this.answerModel = questions.map((q, i) => {
                        const { tabIndex, questionIndex, ...rest} = q;
                        return answerMemo[q.tabIndex] && answerMemo[q.tabIndex][q.questionIndex]; 
                    });

                    this.questions = questions;
                },
                answerModel(v){
                    if (this.isResultsPage) {
                        this.changedAnswerMemoOnResultPage();
                        this.disabledContinue = false;
                        this.notice = '';
                        return;
                    }

                    const { enableNextWhen } = this.getTab(this.stepNumber);
                    let questions = this.getQuestions(this.stepNumber);

                    if (!questions)  {
                        return [];
                    }

                    questions = questions.map((q, i) => ({ ...q, index: i }));

                    const answers = this.answerModel.filter(a => a);
                    const answersValues = answers.reduce((o, a) => ({ ...o, [a.id]: a.value }), {});

                    this.questions = questions.filter(q => {
                        if (!q.showIfQuestion){
                            return true;
                        }

                        const a = answersValues[q.showIfQuestion];

                        return a && (typeof a === 'string' ? a === q.showIfValue : a.indexOf(q.showIfValue) >= 0);
                    });

                    const indexes = this.questions.map(q => q.index);
                    const filteredAnswers = answers.filter(a => indexes.indexOf(a.index) >= 0);

                    const { comparisonType = 'DEFAULT', stepIds = [] } = enableNextWhen || {};

                    if (comparisonType === 'ANY') {
                        this.disabledContinue = !((filteredAnswers.find(a => stepIds.indexOf(a.id) >= 0) || false) && true);
                    } else if (comparisonType === 'ALL') {
                        this.disabledContinue = filteredAnswers.filter(a => stepIds.indexOf(a.id) >= 0).length !== stepIds.length;
                    } else {
                        this.disabledContinue = this.questions.length !== filteredAnswers.length;
                    }

                    this.notice = (filteredAnswers.find(a => a.notice) || {}).notice || '';
                },
                filters: {
                    handler: function(){
                        this.data = {
                            loadingMessage: this.isResultsPage && this.loadingMessage,
                        };


                        if (this.debounce){
                            clearTimeout(this.debounce);
                        }

                        if (!this.isResultsPage) {
                            this.loadData();
                        }else{
                            this.debounce = setTimeout(this.loadData, 600);
                        }

                    },
                    deep: true
                },
                data: {
                    handler: function(d){
                        if (!d || !d.searchResults) {
                            return;
                        }

                        const { TotalResults, remaining, ShowLastPage } = d.searchResults || {};
                        const tabs = d.tabs || [];

                        // set the total number of found results
                        if (TotalResults !== undefined) {
                            this.count = TotalResults
                        }

                        // for pagination
                        !remaining && this.setData(d);

                        this.steps = tabs.map(t => ({ label: t.tabTitleShort }));

                        if (ShowLastPage) {
                            this.stepNumber = this.steps.length;
                        }

                        this.isResultsPage = this.steps.length <= this.stepNumber;

                        this.loadView();
                    },
                    deep: true
                },
                stepNumber(i) {
                    this.tagStepFlag =  true;
                    this.loadView();
                },
                stepAnswers(v){
                }
            },
            created: function() {
                const bars = document.querySelectorAll('.persistent-cta');
                for (var i = 0; i < bars.length; i++){ const e = bars[i]; e.classList.add('persistent-cta--ms'); }
            },
            updated(){
                if (this.isResultsPage) {
                    this.triggerForm();
                }
            },
            methods: {
                // Fetchs the remote data
                loadData: function(){
                    const _this = this;
                    let filters = {...this.filters};

                    this.fetch(function(response){
                        _this.setData(response.data || {});
                    }, {
                        params: {
                            ...this.params,
                            page: this.page,
                            ...filters,
                        },
                        paramsSerializer: function (params) {
                            return qs.stringify(params, {arrayFormat: 'repeat'})
                        },
                    });
                },

                // Pagination methods
                loadMore: function(e){
                    this.setData(this.data);
                },
                setData: function(data){
                    const { searchResults: { Results = [], remaining, ..._searchResults }, ...res } = data;
                    let searchResults = {};

                    if (!remaining) {
                        searchResults = {
                            Results: [
                                ...Results.filter((_, i) => i < this.pageSize )
                            ],
                            remaining: Results.filter((_, i) => i >= this.pageSize ),
                            ..._searchResults
                        };

                        this.onTriggerStepEvent(data);
                    } else {
                        searchResults = {
                            Results: [
                                ...Results,
                                ...remaining.filter((_, i) => i < this.pageSize )
                            ],
                            remaining: remaining.filter((_, i) => i >= this.pageSize ),
                            ..._searchResults
                        };
                    }

                    this.data = {
                        ...res,
                        searchResults,
                        nextPage: searchResults.remaining.length > 0
                    };
                },

                // Step methods
                getTab(stepNumber, data) {
                    const tabs = (data && data.tabs) ||  this.data.tabs || [];
                    return tabs[stepNumber] || {};
                },
                getQuestions(stepNumber, data) {
                    const tab = this.getTab(stepNumber, data);
                    return tab.questions || [];
                },
                loadView() {
                    this.setStepValues();

                    if (this.isResultsPage){
                        return;
                    }

                    this.answerModel = this.answerMemo[this.stepNumber] ? [...this.answerMemo[this.stepNumber]] : [];
                },
                setStepValues() {
                    const tabs = this.data.tabs || [];
                    if (tabs.length === 0) {
                        return;
                    }

                    const answerMemo = this.answerMemo;

                    this.stepValues = answerMemo.map((a, i) => {
                        const tab = tabs[i] || {};

                        if (tab.tabValue) {
                            return tab.tabValue;
                        }

                        if (i >= this.stepNumber) {
                            return '';
                        }

                        if (!a) {
                            return '';
                        }

                        const label = a.map(e => {
                            if (typeof e.value === 'object'){
                                const { MoreLabel = '' } = this.data.searchResults || {};
                                if (e.value.length <= 1) {
                                    return e.value.join();
                                }
                                const count = e.value.length-1;
                                return e.value[0] + ` + ${count} ` + MoreLabel;
                            }

                            return e.value;
                        }).join(' ');
                        return label;
                    });
                },
                onClickNextButton(skip=false) {
                    if (this.isResultsPage) {
                        this.$refs.slideBar.open(); 
                        return;
                    }

                    this.answerMemo = [...this.answerMemo];

                    const indexes = this.questions.map(q => q.index);

                    if(skip){
                        this.answerMemo[this.stepNumber] = this.questions.map(q => this.questionSkipResult(q));
                    } else {
                        const anws = this.answerModel.reduce((a, e) => (!e ? a : {...a, [e.index]: e}), {});
                        this.answerMemo[this.stepNumber] = indexes.map(i => anws[i] || {});
                    }

                    this.answerModel = [];
                    this.stepNumber += 1;
                },
                onClickSkipButton() {
                    this.onClickNextButton(true);
                },
                changeStepNumber(stepNumber) {
                    this.stepNumber = stepNumber;
                },
                changedAnswerMemoOnResultPage(){
                    const answerMemo = [...this.answerMemo];
                    this.questions.forEach((q, i) => {
                        const { tabIndex, questionIndex, ...rest} = q;
                        if (!answerMemo[tabIndex]) {
                            answerMemo[tabIndex] = [];
                        }

                        if (!this.answerModel[i]) {
                            answerMemo[tabIndex][questionIndex] = this.questionSkipResult(q);
                            return;
                        }

                        answerMemo[tabIndex][questionIndex] = this.answerModel[i];
                    });

                    this.answerMemo = answerMemo;
                },
                questionSkipResult(q){
                    return { query: q.apiQuery.reduce((a, e) => ({ ...a, [e]: 'skip' }), {}) };
                },
                triggerTaggingEvent(data, type){
                    if (!data){
                        return;
                    }

                    const dataObject = {
                        event: 'TF-Meter-Selection',
                        type: 'tool',
                        category: 'Meter Selector',
                        ...data
                    };

                    try {
                        if (type === 'immutable') {
                            window.immutableDataLayerPush(dataObject);
                        } else {
                            window.customMutableDataLayerPush(dataObject);
                        }
                    } catch(err) {
                        console.log('Analytics framework error: ', err)
                    }
                },
                onTriggerQuestionEvent(data = {}){
                    if (!Number.isInteger(data.questionIndex)){
                       return;
                    }

                    if (!data || data.value === undefined) {
                        return;
                    }

                    // tagging event
                    const tab = this.getTab(this.stepNumber);
                    const question = this.questions[data.questionIndex];
                    const questionTitle = question.question || tab.tabTitle;
                    const isButton = Boolean(question.button);

                    this.triggerTaggingEvent({
                        action: isButton ? questionTitle : question.filterName,
                        label: isButton ? data.value.label : data.value,
                        elementType: isButton ? 'button' : 'input',
                    });
                },
                onTriggerStepEvent(data = {}){
                    if (!this.tagStepFlag) {
                        return;
                    }

                    this.tagStepFlag = false;

                    // tagging event
                    const i = this.stepNumber;
                    const stepNo = this.padStart(String(i + 1), 2);
                    const matchCount = data.searchResults && this.padStart(String(data.searchResults.TotalResults), 3);

                    if (i < this.steps.length) {
                        this.triggerTaggingEvent({
                            stepNo,
                            matchCount,
                            stepName: this.steps[i].label
                        }, 'immutable');
                    } else if (i >= this.steps.length) {
                        this.triggerTaggingEvent({
                            stepNo,
                            matchCount,
                            stepName: 'COMPLETE'
                        }, 'immutable');

                    }
                },
                padStart(value, padSize = 2){
                    let n =  String(value);
                    while (n.length < padSize) {n = "0" + n;}
                    return n;
                },
                triggerForm() {
                    const buttons = document.querySelectorAll(this.requestQuoteButton);
                    const comments = this.answerMemo.reduce((a, o, i) => {
                        if (!o)  {
                            return a;
                        }

                        const qa = o.filter(e => Boolean(e.label)).map(e => ({ label: e.label + (e.option && e.option.label ? ' in ' + e.option.label : ''), value: e.value }));

                        return qa.length > 0 ? [...a, ...qa] : a;
                    } , []);

                    const commentsText = comments.filter(o => Boolean(o.value)).map(o => o.label.toUpperCase() + ': ' + (Array.isArray(o.value) ? o.value.join(', ') : o.value.toString())).join(' | ');

                    for (var i = 0; i < buttons.length; i++){
                        const button = buttons[i];
                        button.dataset.comments = commentsText;
                    }
                },
            },
            components: {
                'meter-selector-paginator' : {
                    props: ['data', 'isShow'],
                    template: meterSelectorPaginatorTemplate,
                },
                'meter-selector-content' : {
                    props: ['data', 'count', 'isMatch', 'selectedUnit'],
                    data: function() {
                        return {
                        };
                    },
                    computed: {
                        viewProductLabel: function() {
                            return this.data.searchResults.ViewProductLabel;
                        },
                        component(){
                            return this.isMatch && this.count === 1 ? 'product-item-h' : 'product-item-v';
                        }
                    },
                    components: {
                        "product-item-v": {
                            props: ['item', 'selectedUnit', 'viewProductLabel'],
                            template: productItemVTemplate,
                            components: {
                                "bookmark": {
                                    props: ['item'],
                                    data: function() {
                                        return {
                                            isBookmarked: false,
                                            id: null,
                                            type: null
                                        }
                                    },
                                    computed: {
                                        saved: function() {
                                            return store.state.favorites[`${this.type}`];
                                        }
                                    },
                                    watch: {
                                        saved: function() {
                                            this.isBookmarked = this.saved.includes(this.id) ? true : false;
                                        }
                                    },
                                    methods: {
                                        handleBookmark() {
                                            store.commit('updateFavorites', {
                                                id: this.id,
                                                type: this.type,
                                                action: this.isBookmarked ? "remove" : "add"
                                            });
                                            store.dispatch('checkFavorites');
                                        }
                                    },
                                    mounted() {
                                        this.id = this.$refs.bookmark.dataset.productId ? this.$refs.bookmark.dataset.productId : this.$refs.bookmark.dataset.articleId ? this.$refs.bookmark.dataset.articleId : this.$refs.bookmark.dataset.documentId ? this.$refs.bookmark.dataset.documentId : this.$refs.bookmark.dataset.softwareId ? this.$refs.bookmark.dataset.softwareId : null;

                                        this.type = this.$refs.bookmark.dataset.productId ? "productId" : this.$refs.bookmark.dataset.articleId ? "articleId" : this.$refs.bookmark.dataset.documentId ? "documentId" : this.$refs.bookmark.dataset.softwareId ? "softwareId" : null;

                                        this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
                                    }
                                }
                            }
                        },
                        "product-item-h": {
                            props: ['item', 'selectedUnit', 'viewProductLabel'],
                            template: productItemHTemplate,
                            components: {
                                "bookmark": {
                                    props: ['item'],
                                    data: function() {
                                        return {
                                            isBookmarked: false,
                                            id: null,
                                            type: null
                                        }
                                    },
                                    computed: {
                                        saved: function() {
                                            return store.state.favorites[`${this.type}`];
                                        }
                                    },
                                    watch: {
                                        saved: function() {
                                            this.isBookmarked = this.saved.includes(this.id) ? true : false;
                                        }
                                    },
                                    methods: {
                                        handleBookmark() {
                                            store.commit('updateFavorites', {
                                                id: this.id,
                                                type: this.type,
                                                action: this.isBookmarked ? "remove" : "add"
                                            });
                                            store.dispatch('checkFavorites');
                                        }
                                    },
                                    mounted() {
                                        this.id = this.$refs.bookmark.dataset.productId ? this.$refs.bookmark.dataset.productId : this.$refs.bookmark.dataset.articleId ? this.$refs.bookmark.dataset.articleId : this.$refs.bookmark.dataset.documentId ? this.$refs.bookmark.dataset.documentId : this.$refs.bookmark.dataset.softwareId ? this.$refs.bookmark.dataset.softwareId : null;

                                        this.type = this.$refs.bookmark.dataset.productId ? "productId" : this.$refs.bookmark.dataset.articleId ? "articleId" : this.$refs.bookmark.dataset.documentId ? "documentId" : this.$refs.bookmark.dataset.softwareId ? "softwareId" : null;

                                        this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
                                    }
        
                                }
                            }
                        },
                    },
                    watch: {
                    },
                    template: meterSelectorContentTemplate,
                },
                'meter-selector-total': {
                    props: ['count'],
                },
            }
        })
    ] 
});
